// Mirrors Caspian2/Common/Enums/OpportunityStatusEnum.cs
// (numeric values are not contiguous — keep them in sync with the backend enum).
const OpportunityStatusEnum = {
  SpecIncomplete: 1,
  SpecPendingReview: 2,
  PricingRequested: 3,
  PricingComplete: 4,
  ProposalComplete: 6,
  PendingApproval: 7,
  ProposalDelivered: 9,
  ProposalInRevision: 10,
  OpportunityWon: 11,
  OpportunityLost: 12,
  ProposalNegotiation: 13,
  Shortlisted: 14,
  ContractNegotiation: 15,
};

// Returns the enum name for a numeric value (e.g. 11 -> 'OpportunityWon'). Empty string for
// null/undefined; the raw value (as string) for an unknown number.
export const getOpportunityStatusName = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const match = Object.entries(OpportunityStatusEnum).find(([, enumValue]) => enumValue === value);
  return match ? match[0] : String(value);
};

export default OpportunityStatusEnum;
